export const defaultRegistryUrl = 'https://builds.hex.pm';

export const datasource = 'hexpm-bob';
